// exports.baseURL = "http://localhost:3000";
// exports.baseURL = "https://staging.figa.co.nz/api";
// exports.baseURLApp = "https://staging.figa.co.nz";
exports.baseURL = "https://api.figa.co.nz";
exports.baseURLApp = "https://app.admin.figa.co.nz";

